import { capitalizeFirstLetter } from '@/utils/admin/utils';

export const getLeaseStatusColor = (status: string): string => {
  const value = (status || '').toLowerCase();
  switch (value) {
    case 'current':
      return '#4CAF50';
    case 'notice':
      return '#FF9800';
    case 'future':
      return '#2196F3';
    case 'past':
    case 'cancelled':
      return '#F44336';
    default:
      return '#9E9E9E';
  }
};

export const getLeaseStatusLabel = (status: string): string => {
  const value = (status || '').toLowerCase();
  switch (value) {
    case 'current':
      return 'Current Lease';
    case 'past':
      return 'Past Lease';
    case 'future':
      return 'Future Lease';
    case 'notice':
      return 'Lease On Notice';
    default:
      return capitalizeFirstLetter(status || '');
  }
};


